<template>
  <section>
    <b-alert show v-if="isLoading" class="text-center" variant="warning"><h3><b>Loading..</b> Please wait.</h3></b-alert>
    <div class="row" v-else>
      <div class="col-12 col-sm-9">
        <b-card class="mb-3" :header="heading + ', Ticket: ' + itemForm.ticketNumber + ' - Status: '+ ticketStatus" no-body>
          <div class="card-body">
            <div class="row">
              <!-- <div class="col-12" v-if="!itemForm.id && $store.getters['account/hasUserRole']('superadmin')">
                <div class="pull-right">
                  <b-form-group class="col-12" label="">
                    <b-form-checkbox
                      v-model="itemForm.putIntoBackLog"
                      name="check-button"
                      switch
                    >
                      Draft
                    </b-form-checkbox>
                  </b-form-group>
                </div>
              </div> -->
              <div class="col-12 col-md-12" v-if="!itemForm.id && projectsList.length>1">
                <b-form-group label="Project">
                  <b-v-select
                    v-model="itemForm.projectId"
                    :disabled="isViewingItem"
                    :options="projectsList"
                  ></b-v-select>
                </b-form-group>
              </div>
              <div class="col-12 col-md-6">
                <b-form-group label="Priority">
                  <b-v-select
                    v-model="itemForm.priority"
                    :disabled="isViewingItem"
                    :options="priorityList"
                  ></b-v-select>
                </b-form-group>
              </div>
              <div class="col-12 col-md-6">
                <b-form-group label="Type">
                  <b-form-select
                    v-model="itemForm.type"
                    :disabled="isViewingItem"
                    :options="typeList"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-12">
                <b-form-group label="Name">
                  <b-form-input
                    maxlength="45"
                    v-model="itemForm.name"
                    :disabled="isViewingItem && !isEditing"
                  />
                </b-form-group>
              </div>

              <div class="col-12">
                <b-form-group label="Description" :key="itemForm.id">
                  <markdwn-editor
                      ref="toastuiEditor"
                      v-if="!itemForm.id || isEditing"
                      :options="editorOptions"
                      height="250px"
                      initialEditType="wysiwyg"
                      previewStyle="tab"
                    ></markdwn-editor>
                    <div v-else class="vue-prosemirror p-2" style="background-color: #f8f9fa; color: #495057;" >
                      <vue-markdown>{{itemForm.message}}</vue-markdown>
                    </div>
                </b-form-group>
              </div>
              <div class="col-12" v-if="!itemForm.id">
                <UploadImages :max="5"  @changed="handleImages" />
              </div>
            </div>
          </div>
        </b-card>
        <b-card class="mb-3" no-body v-if="itemForm.id">
          <div class="card-body">
            <div class="items ticket-comments">

              <b-card v-for="(comment, key) in itemForm.ticketMessages" :key="comment.id">

                <template #header>
                  <div class="w-100 form-row">
                    <h6 class="col mb-0">
                      <b-avatar size="2em" class="mr-1" variant="secondary"></b-avatar>
                      {{comment.authorName}}
                    </h6>
                    <div class="col-auto pull-right text-sm pt-0">
                      <div>
                      <span
                          v-if="
                            comment.createDateTimeUtc &&
                              !comment.createDateTimeUtc.endsWith('Z')
                          "
                          >{{
                            (comment.createDateTimeUtc + 'Z') | moment('MMMM Do YYYY h:mm a')
                          }}</span
                        >
                        <span v-else-if="comment.createDateTimeUtc">{{
                          comment.createDateTimeUtc | moment('MMMM Do YYYY h:mm a')
                        }}</span>
                        <div style="display: inline-block; position: relative;">
                          <b-button variant="light" size="sm" class="border ml-1" @click="toogleDialogEmoji(comment.id)">😃</b-button>
                          <div
                            v-if="showEmojiDialogFor == comment.id"
                              class="v-emojibox"
                              style="position: absolute; bottom: 40px; left: -50%; z-index: 885">
                            <VEmojiPicker
                              :customEmojis="customEmojiList"
                              :emojisByRow="7"
                              :emojiSize="26"
                              v-show="showEmojiDialog"
                              :style="{ width: '310px', height: '400px' }"
                              labelSearch="Search"
                              lang="en-US"
                              @select="onSelectEmoji(comment.id, $event)"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <b-card-text class="vue-prosemirror">
                  <vue-markdown>{{comment.message}}</vue-markdown>
                </b-card-text>
                <b-card-text v-if="comment.reactions && comment.reactions.length">
                  <div class="comment-reactions">
                    <span class="label label-white" v-for="(reaction, indx) in comment.reactions" v-html="ParseReactionEmoji(reaction)">
                    </span>
                  </div>
                </b-card-text>
                <!-- <a href="#" class="card-link">Card link</a>
                <b-link href="#" class="card-link">Another link</b-link> -->
              </b-card>
            </div>
          </div>
          <template v-slot:header>
            <div class="w-100 form-row">
              <b-alert class="col-12" show variant="warning" v-if="postingComment">Please wait...</b-alert>
              <div class="col-12" v-else>
                <b-form-group label="Leave Comment:" class="mb-0">
                  <prosemirror
                    initialMarkdown=""
                    @contentChangeMarkdown="markdownChangedHandlerComment"
                    :textareaConfig="{name: 'comment-textarea'}"
                  ></prosemirror>
                  <markdwn-editor
                      ref="toastuiCommentEditor"
                      :options="editorOptions2"
                      height="250px"
                      initialEditType="wysiwyg"
                      previewStyle="tab"
                    ></markdwn-editor>
                  <!-- <b-form-textarea
                    rows="2"
                    v-model="commentForm.message"
                  /> -->
                </b-form-group>
                <b-form-group>
                  <b-button
                    type="button"
                    variant="primary"
                    @click="PostComment"
                  >
                    Post Comment
                  </b-button>
                  <b-button
                    v-if="!appendImagesShowOpt"
                    type="button"
                    class="ml-1"
                    variant="secondary"
                    @click="appendImagesShowOpt = true"
                  >
                    <i class="fa fa-upload"></i> Attachments
                  </b-button>
                </b-form-group>
              </div>
              <div class="col-12" v-if="appendImagesShowOpt">
                <UploadImages :max="5"  @changed="handleImages" />
              </div>
            </div>
          </template>
        </b-card>
      </div>

      <aside class="col-12 col-sm-3">
        <b-card header="Actions">
          <b-button
            v-if="!isViewingItem"
            :disabled="savingItem"
            variant="primary"
            block
            type="submit"
            @click="SaveForm"
          >
            <span v-if="savingItem">Saving...</span>
            <span v-else>Save Changes</span>
          </b-button>
          <b-button
            v-if="!isEditing && (itemForm.status == 'backlog' || itemForm.status == 'triage') && itemForm.id"
            variant="warning"
            block
            type="submit"
            @click="isEditing = !isEditing"
          >
            <span>Edit Ticket</span>
          </b-button>
          <b-button
            v-if="isEditing && (itemForm.status == 'backlog' || itemForm.status == 'triage') && itemForm.id"
            variant="info"
            block
            type="submit"
            @click="SaveUpdates"
          >
            <span>Save Changed</span>
          </b-button>
          <button
            v-if="isViewingItem && !isEditing && itemForm.submittedBy == 'Customer' && !itemForm.linearIssueId && itemForm.status != 'completed' && itemForm.status != 'canceled'"
            :disabled="savingItem"
            class="mt-2 btn btn-block btn-outline-warning"
            @click="createNewBasedOn(itemForm)"
          >
            <span>Create new Ticket based on this</span>
          </button>
          <button
            v-if="isViewingItem && !isEditing && itemForm.submittedBy == 'Customer' && !itemForm.linearIssueId && itemForm.status != 'completed' && itemForm.status != 'canceled'"
            :disabled="savingItem"
            class="mt-2 btn btn-block btn-outline-danger"
            @click="raiseToLinear()"
          >
            <span>Forward to Tech Support</span>
          </button>
          <button
            v-if="isViewingItem && !isEditing && itemForm.submittedBy == 'Customer' && (itemForm.status == 'completed' || itemForm.status == 'canceled')"
            :disabled="savingItem"
            class="mt-2 btn btn-block btn-outline-info"
            @click="changedStatus(itemForm.id, 'completed')"
          >
            <span>Re-Open</span>
          </button>
          <button
            v-if="isViewingItem && !isEditing && itemForm.status != 'completed' && itemForm.status != 'canceled'"
            :disabled="savingItem"
            class="mt-2 btn btn-block btn-outline-success"
            @click="changedStatus(itemForm.id, 'completed')"
          >
            <span>Mark as Completed</span>
          </button>
          <router-link
            :disabled="savingItem"
            class="mt-2 btn btn-block btn-outline-danger"
            :to="{ name: 'Support.Tickets.All' }"
          >
            <span v-if="isViewingItem">Back To List</span>
            <span v-else>Cancel</span>
          </router-link>
          <b-form-group label="Change Status:" class="mt-2"
          v-if="itemForm.id && itemForm.submittedBy == 'Customer' && itemForm.subStatus == ''">
            <b-form-select
              v-model="itemForm.status"
              :options="statusList"
              @change="changedStatus(itemForm.id, itemForm.status)"
            ></b-form-select>
          </b-form-group>
        </b-card>
        <!-- <b-card header="Collaboration" v-if="itemForm.id">
          <div class="border b p-2 pr-3" v-for="(usr, index) in itemForm.collaboratorWithUsers" :key="usr.id">
          <i class="fa fa-user ml-2"></i> {{usr.fullName}} ({{usr.email}})
          </div>
          <template v-slot:footer>
            <b-form-group label="Share with:" label-for="item-shareWith">
              <b-v-select
                v-model="shareWithuserId"
                :searchable="true"
                :options="posBy"
              />
            </b-form-group>
            <b-button block variant="info" @click="ShareWith">
              Share
            </b-button>
          </template>
        </b-card> -->
      </aside>

    </div>
  </section>
</template>

<script>
let refOfHttp = null;
let refOfEditor = false;
let refOfCommentEditor = false;

let addImageBlobHook = function(blob, callback, source) {
  if(refOfEditor) {
    let fileName = blob.name;
    let reader = new FileReader();
    reader.onload =  function(_a) {
      let formData = new FormData();
      formData.append('formFile', blob);
      formData.append('extension', fileName.split('.').pop());
      let headers = { 'Content-Type': 'multipart/form-data' };
      refOfHttp.post('/api/common/tickets/imageUpload', formData, { headers }).then((resp) => {
        let getUrl = window.location;
        let baseUrl = getUrl .protocol + '//' + getUrl.host + '/';
        let oldContent = refOfCommentEditor.editor.getMarkdown();
        refOfCommentEditor.editor.setMarkdown(oldContent + "\r\n "+ " \r\n" + '!['+fileName+']('+resp.data.url+')'+ "\r\n  "+ "  \r\n  ")
      });
    };
    reader.readAsDataURL(blob);
  }
  callback();
  return false;
};

let addImageBlobHook2 = function(blob, callback, source) {
  if(refOfCommentEditor) {
    let fileName = blob.name;
    let reader = new FileReader();
    reader.onload =  function(_a) {
      let formData = new FormData();
      formData.append('formFile', blob);
      formData.append('extension', fileName.split('.').pop());
      let headers = { 'Content-Type': 'multipart/form-data' };
      $http.post('/api/common/tickets/imageUpload', formData, { headers }).then((resp) => {
        let getUrl = window.location;
        let baseUrl = getUrl .protocol + '//' + getUrl.host + '/';
        let oldContent = refOfCommentEditor.editor.getMarkdown();
        refOfCommentEditor.editor.setMarkdown(oldContent + "\r\n "+ " \r\n" + '!['+fileName+']('+resp.data.url+')'+ "\r\n  "+ "  \r\n  ")
      });
    };
    reader.readAsDataURL(blob);
  }
  callback();
  return false;
};
import { Editor } from '@toast-ui/vue-editor';
import CustomEmojis from '@/helpers/custom-emojis.js';
import { VEmojiPicker } from 'v-emoji-picker';
import UploadImages from "vue-upload-drop-images"
import VueMarkdown from 'vue-markdown'
//import ProsemirrorEditor from '@/views/components/ProsemirrorEditor.vue'
//import ProsemirrorEditor from "vue-prosemirror-editor"
import { mapState, mapGetters } from 'vuex';
import { mapStoreGetSet } from '@/helpers/utils/storeHelpers.js';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';

export default {
  mixins: [crudMixinGen('support-tickets'), myCommonDataMixin],
  components: {
    'markdwn-editor': Editor,
    VEmojiPicker,
    UploadImages,
    'vue-markdown': VueMarkdown
  },
  props: {
    id: {
      type: String,
      default: '',
      required: false
    }
  },

  data: () => ({
    editorOptions: {
      hooks: {
        addImageBlobHook: addImageBlobHook,
      },
      minHeight: '200px',
      language: 'en-US',
      useCommandShortcut: true,
      usageStatistics: true,
      hideModeSwitch: false,
      toolbarItems: [
        ['heading', 'bold', 'italic', 'strike'],
        ['hr', 'quote'],
        ['ul', 'ol', 'task', 'indent', 'outdent'],
        ['table', 'image', 'link'],
        ['code', 'codeblock'],
        ['scrollSync'],
      ],
    },
    editorOptions2: {
      hooks: {
        addImageBlobHook: addImageBlobHook2,
      },
      minHeight: '200px',
      language: 'en-US',
      useCommandShortcut: true,
      usageStatistics: true,
      hideModeSwitch: false,
      toolbarItems: [
        ['heading', 'bold', 'italic', 'strike'],
        ['hr', 'quote'],
        ['ul', 'ol', 'task', 'indent', 'outdent'],
        ['table', 'image', 'link'],
        ['code', 'codeblock'],
        ['scrollSync'],
      ],
    },
    appendImagesShowOpt: false,
    isEditing: false,
    postingComment: false,
    customEmojiList: CustomEmojis.list,
    showEmojiDialog: false,
    showEmojiDialogFor: '',
    statusList: [
      //{ value: 'backlog', text: 'Draft' },
      //{ value: 'triage', text: 'Triage' },
      { value: 'unstarted', text: 'Open' },
      { value: 'started', text: 'In Progress' },
      { value: 'canceled', text: 'Canceled' },
      { value: 'completed', text: 'Completed' },
    ],
    usersAll: [],
    shareWithuserId: '',
    uploadedFiles: [],
    refreshHandler: false,
    heading: 'Ticket Form',
    // subheading: 'Here you create or edit your Scheduled Products.',
    // icon: 'pe-7s-graph text-success',
    tempSug: '',
    readyToLoad: false,

    commentForm: {
      message: '',
    },
    priorityList: [
      { value: 1, text: 'Low' },
      { value: 2, text: 'Medium' },
      { value: 3, text: 'High' },
      { value: 4, text: 'Urgent' },
    ],
    shipItemsFields: [
      { key: 'sku', label: 'SKU', sortable: false },
      { key: 'name', label: 'Name', sortable: false },
      { key: 'quantity', label: 'Quantity', sortable: false },
      { key: 'actions' }
    ],
    shipItemsFieldsView: [
      { key: 'sku', label: 'SKU', sortable: false },
      { key: 'name', label: 'Name', sortable: false },
      { key: 'quantity', label: 'Quantity', sortable: false }
    ]
  }),

  computed: {
    ticketStatus:{
      get() {
        let status = 'Triage';
        if(this.itemForm.putIntoBackLog) {
          status = 'Draft';
        }
        if(this.itemForm && this.itemForm.id) {
          if(this.itemForm.subStatus) {
            status = this.itemForm.subStatus;
          } else {
            if(this.itemForm.status == 'triage') {
              status = 'Triage';
            } else if(this.itemForm.status == 'backlog') {
              status = 'Draft';
            } else if(this.itemForm.status == 'completed') {
              status = 'Completed';
            } else if(this.itemForm.status == 'unstarted') {
              status = 'Open';
            } else if(this.itemForm.status == 'canceled') {
              status = 'Cancelled';
            } else if(this.itemForm.status == 'started') {
              status = 'In Progress';
            }
          }
        }
        return status;
      },
      set(old, val) {}
    },
    posBy: {
      get() {
        let arrs = [];
        //arrs.push({ value: '', text: 'Any User' });
        if(this.usersAll && this.usersAll.length>0) {
          this.usersAll.forEach(itm => {
            arrs.push({
              value: itm.id,
              text: itm.fullName + ' (' + itm.email + ')'
            });
          });
        }
        return arrs;
      },
      set(old, val) {}
    },
    ...mapGetters('account', [
      'getUserData',
      'isLoggedIn'
    ]),
    ...mapState('support-tickets', ['typeList']),
    isViewingItem: {
      get() {
        let isTrue = false;
        if (this.itemForm.id) {
          isTrue = true;
        }
        return isTrue;
      },
      set(old, val) {}
    }
  },
  watch: {
    id: {
      handler: function(val, oldVal) {
        if (val) {
          this.isLoading = true;
          this.ResetForm();
          this.LoadItem(val);
          this.refreshHandler = setInterval(() => {
            if(!this.isEditing) {
              this.LoadItem(val, true);
            }
          }, 30 * 1000);
        } else {
          this.ResetForm();
          this.AutoFillNameIfEmpty();
          this.readyToLoad = true;
          let query = this.$route.query;
          setTimeout(() => {
            if(query && query.message && query.name) {
              this.itemForm.message = query.message;
              this.itemForm.name = query.name;
              this.$refs.toastuiEditor.editor.setMarkdown(query.message);
            }
          }, 200)
        }
      },
      deep: true
    },
  },
  beforeDestroy() {
    if(this.refreshHandler) {
      clearInterval(this.refreshHandler);
      this.refreshHandler = false;
    }
  },
  beforeMount() {
    if (this.id) {
        this.isLoading = true;
    }
  },
  mounted() {
      if (this.id) {
        this.isLoading = true;
        this.ResetForm();
        this.LoadItem(this.id);
        this.refreshHandler = setInterval(() => {
          if(!this.isEditing) {
            this.LoadItem(this.id);
            refOfEditor = this.$refs.toastuiEditor;
            refOfCommentEditor = this.$refs.toastuiCommentEditor;
          }
        }, 30 * 1000);
      } else {
        this.ResetForm();
        this.AutoFillNameIfEmpty();
        this.readyToLoad = true;
      }
  },

  methods: {
    ApproveTicketQA() {
      this.itemForm.subStatus = 'Approved';
      this.itemForm.status = 'completed';
      this.SaveItem(null)
      .then((resp) => {
        this.$swal('Ticket was Closed!');
      })
    },
    ParseReactionEmoji(reaction) {
      let reactInfo = this.customEmojiList.find(a =>a.aliases.includes(reaction.name));
      if(reactInfo) {
        return '<span title="'+reaction.byUser+' reacted with :'+reaction.name+':">'+reactInfo.data+'</span> ';
      } else {
        return '<span title="'+reaction.byUser+' reacted with :'+reaction.name+':">😀</span>';
      }
    },
    toogleDialogEmoji(id) {
      this.showEmojiDialogFor = id;
      this.showEmojiDialog = !this.showEmojiDialog;
    },
    onSelectEmoji(id, emoji) {
      let emojiIcon = emoji.data;
      let emojiName = emoji.aliases[0];
        this.$http
          .post('/api/common/ticketMessages/leaveReaction/' + id + '/'+ emojiName)
          .then(resp => {
            let comment = this.itemForm.ticketMessages.find(a => a.id == id);
            if(comment && resp.data.reaction)
              comment.reactions.push(resp.data.reaction)
            this.showEmojiDialogFor = '';
            this.showEmojiDialog = false;
          })
          .catch(err => {
            console.error('error on emoji', emojiIcon, err.response.data)
          });
    },
    createNewBasedOn(ticket) {
      let previousMessage = ticket.message;
      previousMessage = previousMessage.replace(/(\r?\n){2,}/g, '\n> ');
      previousMessage = '\n\nFrom Customer:\n> '+ previousMessage.replace(/(\r?\n)/g, '\n> ');
      let ticketNewName = 'Help With Issue '+ticket.ticketCustomerNumber+': '+ticket.name ;
      this.$router.push({ name: 'Support.Tickets.Create',
        query: {message: previousMessage, name: ticketNewName}
       });
    },
    raiseToLinear() {
      let itm = this.itemForm;
      if(itm != null) {
        this.$http
          .post('/api/common/tickets/sendToLinear/' + this.id)
          .then(resp => {
              this.$swal('Ticket was sent to Linear!');
              this.LoadItem(this.id);
          })
          .catch(err => {});
      }
    },
    changedStatus(id, status) {
      let itm = this.itemForm;
      if(itm != null) {
        itm.status = status;
        this.$http
          .post('/api/common/tickets/changeStatus/' + id + '/'+ status)
          .then(resp => {
              this.$swal('Ticket status updated!');
          })
          .catch(err => {});
      }
    },
    ShareWith() {
      if(this.shareWithuserId) {
        let usrFound = this.usersAll.find(a => a.id == this.shareWithuserId);
        if(usrFound != null) {
          this.itemForm.collaboratorUserIds.push(this.shareWithuserId);
          this.itemForm.collaboratorWithUsers.push(JSON.parse(JSON.stringify(usrFound)));
          this.shareWithuserId = ''
          this.$http
            .put('/api/common/tickets/'+this.itemForm.id, this.itemForm)
            .then(resp => {
            })
            .catch(err => {});
        }
      }
    },
    loadUsers(hnl = () => {}) {
      // if(this.itemForm.projectId) {
      //   this.$http
      //     .get('/api/userspublic/collab/'+this.itemForm.projectId)
      //     .then(resp => {
      //       console.log('get userspublic', resp.data);
      //       this.usersAll = resp.data;
      //       hnl();
      //     })
      //     .catch(err => {});
      // }
    },
    handleImages(files){
        files.forEach((file) => {
          if(this.uploadedFiles.find(a => a.name == file.name) == null) {
            const formData = new FormData();
            formData.append('formFile', file);
            const headers = { 'Content-Type': 'multipart/form-data' };
            this.$http.post('/api/common/tickets/imageUpload', formData, { headers }).then((resp) => {
              this.uploadedFiles.push({
                name: file.name,
                size: file.size,
                url: resp.data.url
              })
            });
          }
        })
    },
    markdownChangedHandlerComment(value) {
      this.commentForm.message = value;
    },
    markdownChangedHandler(value) {
      this.itemForm.message = value;
    },
    CloseTicket() {
      this.itemForm.isOpen = false;
      this.SaveItem()
      .then((resp) => {
        this.$swal('Ticket was Closed!');
      })
    },
    SaveUpdates() {
      this.isEditing = false;
      this.SaveItem()
      .then((resp) => {
        this.$swal('Ticket changes were Saved!');
      })
    },
    SaveForm() {
      if(this.myProjects.length == 0) {
        alert('Your account does not have access to any support projects! Contact support@ux.app to have your account permissions updated!');
        return;
      }
      this.itemForm.message = this.$refs.toastuiEditor.invoke('getMarkdown');
      if(this.itemForm.message.includes('data:image')) {
        this.itemForm.message = this.itemForm.message.replace(/\((data:image\/[^;]+;base64[^]+)\)/g,'(_bad_url)');
        alert('Pasting images directly into the message body is not allowed! Please use the file picker instead!');
        return;
      }
      this.savingItem = true;
      let defaultProjId = this.myProjects[0].id;
      this.itemForm.projectId = defaultProjId;
      let getUrl = window.location;
      let baseUrl = getUrl .protocol + '//' + getUrl.host + '/';
      if(this.uploadedFiles.length) {
        let appendToMessage =  "\n\nAttachments:";
        this.itemForm.message += appendToMessage;
        this.uploadedFiles.forEach((img) => {
          let fullUrl = img.url;
          let appendToMessage =  "\n\n" + '!['+img.name+']('+fullUrl+')'
          this.itemForm.message += appendToMessage;
        })
      }
      this.itemForm.userEmail = this.getUserData.email;
      this.itemForm.userFullName = this.getUserData.fullName;
      this.itemForm.userId = this.getUserData.id;
      this.$http
      .post('/api/common/tickets', this.itemForm)
      .then((resp) => {
        this.appendImagesShowOpt = false;
        this.uploadedFiles = [];
        this.$router.push({name: 'Support.Tickets.All'});
        this.$swal('Ticket was Created!');
        this.savingItem = false;
      }).catch((err) => {
        this.savingItem = false;
      });
    },
    PostComment() {
      let commentFormInfo = JSON.parse(JSON.stringify(this.commentForm));
      commentFormInfo.message = this.$refs.toastuiCommentEditor.editor.getMarkdown();
      if(this.itemForm.id && commentFormInfo.message) {
        this.postingComment = true;
        commentFormInfo.ticketId = this.itemForm.id;
        commentFormInfo.authorEmail = this.getUserData.email;
        commentFormInfo.authorName = this.getUserData.fullName;
        commentFormInfo.userId = this.getUserData.id;

        if(this.$refs.toastuiCommentEditor && this.$refs.toastuiCommentEditor.editor)
          this.$refs.toastuiCommentEditor.editor.setMarkdown('');
        this.commentForm.message = '';

        let getUrl = window.location;
        let baseUrl = getUrl .protocol + '//' + getUrl.host + '/';
        if(this.uploadedFiles.length) {
          let appendToMessage =  "\n\nAttachments:";
          this.itemForm.message += appendToMessage;
          this.uploadedFiles.forEach((img) => {
            let fullUrl = img.url;
            let appendToMessage =  "\n\n" + '!['+img.name+']('+fullUrl+')'
            commentFormInfo.message += appendToMessage;
          })
        }

        this.$http
          .post('/api/common/ticketMessages', commentFormInfo)
          .then(resp => {
            this.appendImagesShowOpt = false;
            this.uploadedFiles = [];
            this.postingComment = false;
            let item = resp.data;
            this.itemForm.ticketMessages = [item,...this.itemForm.ticketMessages]
          })
          .catch(err => {});
      }
    },

    LoadItem(id) {
      this.$http
        .get('/api/common/tickets/' + id)
        .then(resp => {
          this.isLoading = false;
          let item = resp.data;
          this.readyToLoad = true;
          this.itemForm = item;
          this.AutoFillNameIfEmpty();
          this.loadUsers();
          this.$refs.markdownEditor.simplemde.togglePreview();
        })
        .catch(err => {});
    },

    AutoFillNameIfEmpty() {
      if ('' == this.itemForm.ticketNumber) {
        this.AutoFillName();
      }
    },

    AutoFillName() {
      let posOrdName = 'T' + (parseInt(new Date()/1));
      this.tempSug = posOrdName;
      this.itemForm.ticketNumber = this.tempSug;
    },
  },
};
</script>
